import React from "react";
import Media from "react-media";

import "./Footer.styles.scss";

interface FooterProps {
	style?: any;
}

const Footer = (props: FooterProps) => {
	const navItems = [
		{
			title: "Privacy Policy",
			link: "https://www.vatom.com/privacy-policy",
		},
		{
			title: "Terms of Service",
			link: "https://www.vatom.com/terms",
		},
		{
			title: "Support",
			link: "https://support.vatom.com/hc/en-us/requests/new",
		},
	];

	return (
		<Media query={{ maxWidth: 600 }}>
			{(isMobile) => (
				<div
					className={`footer ${isMobile ? "mobile-footer" : ""}`}
					style={{ ...(props.style || {}) }}
				>
					<div className="footer-menu">
						<span>&copy; Copyright {new Date().getFullYear()} Vatom, Inc.</span>
						{navItems.map((item, index) => (
							<a key={index} className="nav-item" href={item.link} target="_blank">
								{item.title}
							</a>
						))}
					</div>
				</div>
			)}
		</Media>
	);
};

export default Footer;
